import {
  SET_USER_TOKEN,
  UPDATE_AUTH_USER,
  UPDATE_LOAD_USER,
  SEND_FORGET_PASSWORD_EMAIL,
} from '../../@jumbo/constants/ActionTypes';

export const setToken = token => {
  return dispatch => {
    dispatch({
      type: SET_USER_TOKEN,
      payload: token,
    });
  };
};

export const setAuthUser = user => {
  return dispatch => {
    dispatch({
      type: UPDATE_AUTH_USER,
      payload: user,
    });
  };
};

export const updateLoadUser = loading => {
  return dispatch => {
    dispatch({
      type: UPDATE_LOAD_USER,
      payload: loading,
    });
  };
};

export const setForgetPassMailSent = status => {
  return dispatch => {
    dispatch({
      type: SEND_FORGET_PASSWORD_EMAIL,
      payload: status,
    });
  };
};
